import { useState } from 'react';
import { t } from '../i18n/index.js';
import { discardOp } from '../platform/saveStatus.js';
import { Button } from './ui.js';

/**
 * Nachprüfung 0.167.2: Handlungen für ungesicherte Entwürfe – im Kopf (SaveStatus) und im globalen Hinweis (Shell).
 * Bewusst ohne `deLazy` (Startpaket): die Texte stehen in `de.ts`.
 */
/** Ungesicherten Entwurf bewusst verwerfen – mit Rückfrage, weil der Text danach weg ist */
export function DiscardButton({ contentKey, op }: { contentKey: string; op: { id: string; label: string } }) {
  const [sure, setSure] = useState(false);
  return sure ? (
    <Button variant="danger" onClick={() => discardOp(contentKey, op.id)} data-save-discard="">
      {t('save.discardSure', { what: op.label })}
    </Button>
  ) : (
    <Button variant="ghost" onClick={() => setSure(true)}>
      {t('save.discard')}
    </Button>
  );
}

/** R04: Text, der nirgends dauerhaft liegt, wenigstens kopieren können */
export function CopyButton({ op }: { op: { label: string; copy?: () => string } }) {
  const [done, setDone] = useState(false);
  return (
    <Button
      variant="ghost"
      onClick={() =>
        void navigator.clipboard
          ?.writeText(op.copy!())
          .then(() => setDone(true))
          .catch(() => {})
      }
      data-save-copy=""
    >
      {done ? t('save.copied') : t('save.copy', { what: op.label })}
    </Button>
  );
}
